import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import styles from './AttachmentReminder.module.scss';
export const AttachmentReminder = () => {
    const { t } = useTranslation();
    return (_jsxs("div", Object.assign({ className: styles.reminder }, { children: [_jsx("span", Object.assign({ className: styles.text }, { children: t('label.provide_results') })), _jsx("div", Object.assign({ className: styles.icon }, { children: _jsx(Icon, { type: "info", size: 24 }) }))] })));
};
